
var navHandler = {
    $primaryNavBg: $('.subitems-bg'),
    $primaryNavTrigger: $('.primary-nav-trigger'),
    $primaryNavCloseTrigger: $('.primary-nav-close-trigger'),
    $pageNav: $('.page-nav'),
    $iconHamburger: $('.hamburger-menu svg'),
    $mobileMenuContainer: $('.mobile-menu-container'),
    $primaryNavSmallTrigger: $('.primary-nav-small-trigger'),
    $html: $('html'),
    $leftFloatingLogo: $('.left-floating-logo'),
    $rightFloatingLogo: $('.right-floating-logo'),
    $sideTextContainer: $('.side-text-container'),
    $copyLink:      $('[href="#copy-link"]'),
    scrollBarWidth: 17,
    navTimeOut: null,
  
    bannerHandler: function(scrollTop) {
        var $header  = $('header'); 
        var isBanner = $header.hasClass('is-banner');
        if (isBanner) {
            var $banner = $('.notification-banner');  
            var bannerHeight = $banner.outerHeight();
            var $navLogo = $('.nav-logo');
            // 20220406: PH requested to keep the nav logo on all pages
            if (scrollTop > 10) {
                if (bannerHeight > 0) { 
                    $banner.css({
                        'margin-top': '-'+bannerHeight+'px'  
                    });
                    $header.css({
                        'margin-top': '0px'
                    })
                }
                //$navLogo.addClass('is-show');
            } else {
                if (bannerHeight > 0) { 
                    $banner.css({
                        'margin-top': '-'+bannerHeight+'px'  
                    });
                    $header.css({
                        'margin-top': bannerHeight+'px'
                    })
                }
            //$navLogo.removeClass('is-show');
            }
        }
    },
  
    animateSubmenu: function($submenu) {
        var $leftSection = $submenu.find('.left-section .subitem .menu-text');
        gsap.from($leftSection.toArray(), {
            duration: 0.25, 
            x: -36,
            ease: "power2.inOut",
            opacity: 0,
            stagger: 0.075,
        });
        var $rightSection = $submenu.find('.right-section .primary-nav.subnav');
        gsap.from($rightSection.toArray(), {
            duration: 0.25, 
            x: 36,
            ease: "power2.inOut",
            opacity: 0,
            stagger: 0.075,
        });
        var $closeButton = $submenu.find('.primary-nav-close-trigger');
        gsap.from($closeButton.get(0), {
            rotation: 90,
            duration: 0.2,
        });
    },
  
    openNav: function($trigger) {
        var self = this;
        this.$html.addClass('disable-scroll');
        $("body").css({'padding-right': this.scrollBarWidth+'px'});
        if (!this.$primaryNavBg.hasClass('active')) {
            this.$primaryNavBg.addClass('active');
            setTimeout(function() {
                $trigger.parent().addClass('active');
                var $subItems = $trigger.parent().find('.subitems');
                self.animateSubmenu($subItems);
                var $searchInput = $subItems.find('form#search-form input#s');
                if ($searchInput.length > 0) {
                    $searchInput.focus();
                }
            }, 150);
        } else {
            $trigger.parent().addClass('active');
            self.animateSubmenu($trigger.parent().find('.subitems'));
        }
    },
  
    closeNav: function($trigger) {
        var self = this;
        if (typeof $trigger != 'undefined') {
            $trigger.parent().removeClass('active');
        } else {
            // close any opened menu
            this.$pageNav.removeClass('active');
        }
        var $stillOpened = this.$pageNav.filter('.active');
        if ($stillOpened.length == 0) {
            this.$mobileMenuContainer.removeClass('active');
            this.$html.removeClass('disable-scroll');
            $("body").css({'padding-right': 0});
            this.$primaryNavBg.addClass('disappearing');
            setTimeout(function() {
                self.$primaryNavBg.removeClass('disappearing active');
            }, 100);
        }
    },
  
    init: function() {
        var self = this;
        self.$primaryNavTrigger.on('click', function(e) {
            $('.accessibility-widgets-container').removeClass('active');
            e.stopPropagation();
            var $trigger = $(this);
            var $nav = $trigger.parent();
    
            if ($nav.hasClass('active')) {
                self.closeNav($trigger);
            } else {
                var $otherOpen = self.$pageNav.filter('.active');
                if ($otherOpen.length > 0) $otherOpen.removeClass('active');
                if (self.navTimeOut) self.navTimeOut = null;
                self.navTimeOut = setTimeout(function() {
                    self.openNav($trigger);
                }, 100);
            }
        });
  
        self.$pageNav.each(function() {
            var selfNav = $(this);
            var $normalBtn = selfNav.children('a');
            var $navBtn = selfNav.find('.primary-nav-trigger');
            var $triggNavBtn = selfNav.find('.subitem:first-child a , .rs-item:last-child a');
            
            $normalBtn.on('focusin', function(e) {
                //if (selfNav.siblings('.page-nav.active').length > 0 && Foundation.MediaQuery.is('medium')) {
                if (selfNav.parent().find('.page-nav.active').length > 0 && Foundation.MediaQuery.is('medium') && !selfNav.hasClass('is-sub')) {
                    //var $trigger = selfNav.siblings('.page-nav.active').find('.primary-nav-trigger');
                    var $trigger = selfNav.parent().find('.page-nav.active').find('.primary-nav-trigger');
                    self.closeNav($trigger);
                }
        
                var $subNavBtn = selfNav.find('.subitem:first-child a');
                if (selfNav.hasClass('is-sub')) {
                    if (selfNav.hasClass('active')) selfNav.prev().children('a').focus();
                    else $subNavBtn.focus();
                }
            });
    
            if (selfNav.hasClass('has-subitems')) {
                $triggNavBtn.on('focusin', function(e) {
                    if (!selfNav.hasClass('active')) $navBtn.click();
                });
            }
        });
  
        self.$primaryNavCloseTrigger.on('click', function(){
            self.closeNav();
        });
  
        self.$iconHamburger.on('click', function(){
            self.$mobileMenuContainer.toggleClass('active');
            self.$html.addClass('disable-scroll');
            self.$primaryNavSmallTrigger.each(function(){
                var subitem = $(this).next();
                $(subitem).removeClass('active');  
            })
            
            self.$leftFloatingLogo.css({
                'left': '0px',
                'top': '8%'  
            });
    
            self.$rightFloatingLogo.css({
                'right': '0px',
                'top': '50%'
            });
    
        });
  
        self.$primaryNavSmallTrigger.on('click', function(){
            var subitem = $(this).next();
            $(subitem).toggleClass('active');
        });
    
        self.getScrollBarWidth();
  
        // accessibility
        $('main').attr('tabindex','-1').attr('aria-label','Main Content');
        $('a[href="#main-content"]').on("click", function() {
            $('main').focus();
        })
  
        self.$copyLink.on('click', function(e) {
            e.preventDefault();
            navigator.clipboard.writeText(window.location.href);
            let $tooltip = $(this).find('.tooltip');
            $tooltip.addClass('active');
            setTimeout(() => {
                $tooltip.removeClass('active');
            }, 1000);
        })
    },
  
    activateItemIntoView: function(itemId) {
        var $item;
        if ($.type(itemId) === 'string') {
            $item = $("#"+itemId);
        } else {
            $item = itemId;
        }
        if ($item.length > 0) {
            $('.reveal').foundation('close');
            $('html,body').animate({scrollTop: $item.offset().top - headerHeight - 42}, 'slow');  
        }
    },
  
    getScrollBarWidth: function() {
        var $outer = $('<div>').css({visibility: 'hidden', width: 100, overflow: 'scroll'}).appendTo('body'),
            widthWithScroll = $('<div>').css({width: '100%'}).appendTo($outer).outerWidth();
        $outer.remove();
        this.scrollBarWidth = 100 - widthWithScroll;
    },
  
    adjustMainMarginTop: function() {
        var bannerHeight = $('.notification-banner').outerHeight();
        if (!bannerHeight) bannerHeight = 0;
        $("main").css({'margin-top': ($('header').outerHeight()+bannerHeight)+'px'});
    },
  
}  

var accessibilityHandler = {
    availableOptions: {},
    render: function(accessType) {
        var currentOption = Cookies.get('access-'+accessType);
        if (!currentOption) return;
        for (var i=0; i<this.availableOptions[accessType].length; i++) {
            $('body').removeClass(this.availableOptions[accessType][i]);
        }
        $('body').addClass(currentOption);
        $('.accessibility-widget.'+accessType+' .accessibility-selector-item').removeClass('active');
        $('.accessibility-widget.'+accessType+' .accessibility-selector-item.'+currentOption).addClass('active');
        this.adjustWidgetPosition();
        $('body').trigger('accessibility.optionchanged');
    },
    adjustWidgetPosition: function() {
      // resizing font might move the toggler to left of screen, obscuring the whole widgets panel
      // commented on 06/30 2023 due to toggler being always on the right side of screen, no need to adjust position
      /*
      $('.accessibility-toggler').each(function() {
        var $widgetsPanel = $(this).parents('.accessibility-widgets-container').find('.accessibility-widgets');
        if ($widgetsPanel.offset().left < 0) {
          $widgetsPanel.addClass('left');
        } else {
          $widgetsPanel.removeClass('left');
        }
      });
      */
    },
    setOption: function(accessType, value) {
      var validValue = this.availableOptions[accessType].indexOf(value) != -1;
      if (!validValue) return;
      Cookies.set('access-'+accessType, value);
      this.render(accessType);
    },
    setOptionFromParam: function(accessType) {
      var optionUrlParam = new RegExp('[\?&]'+accessType+'=([^&#]*)').exec(window.location.href);
        if (optionUrlParam) {
            this.setOption(accessType,optionUrlParam[1]);
            this.render(accessType);
        } else {
            return false;
        }
    },
    toggleWidgets: function($element) {
      $element.parents('.accessibility-widgets-container').toggleClass('active');
      this.adjustWidgetPosition();
    },

    init: function() {
        var self = this;
        this.availableOptions = accessOptions;
        $.each(this.availableOptions, function(key, options) {
            if (!self.setOptionFromParam(key)) {
                self.render(key);
            }
        });
        $('.accessibility-widget-title a').on("click", function(e) {
            e.stopPropagation();
            var $nextOption = $(this).parents('.accessibility-widget').find('.accessibility-selector .active').next();
            if ($nextOption.length == 0) {
                $nextOption = $(this).parents('.accessibility-widget').find('.accessibility-selector-item').eq(0);
            }
            $nextOption.trigger('click');
        });
        $('.accessibility-toggler a').on("click", function(e) {
            e.stopPropagation();
            self.toggleWidgets($(this));
        });
        $('.accessibility-selector-item').on("click", function(e) {
            e.stopPropagation();
            var $current = $(this);
            var accessType = $current.data('accessibility-type');
            var value = $current.data('accessibility-option');
            self.setOption(accessType, value);
        });
        $('.accessibility-widgets').on("keydown", function(e) {
            if (!(e.key == 'Tab' || e.keyCode == 9)) return;
            var $siblingsAnchors = $(this).find('a');
            if (e.shiftKey) {
                if ($siblingsAnchors.get(0) === document.activeElement) {
                    self.toggleWidgets($(this));
                }
            } else {
                if ($siblingsAnchors.get($siblingsAnchors.length - 1) === document.activeElement) {
                    self.toggleWidgets($(this));
                }
            }
            // if ($siblingsAnchors[0] == this || $siblingsAnchors[$siblingsAnchors.length-1] == this) {
            //   $(this).parents('.accessibility-widgets-container').toggleClass('active');
            //   self.adjustWidgetPosition();  
            // }
        });
        $('body').on('click', function() {
            $('.accessibility-widgets-container').removeClass('active');
        });
    }
};

jQuery(document).ready(function($) {
    const $iframeMailing = $('iframe.iframe-mailing');

    navHandler.init();
    accessibilityHandler.init();
    navHandler.bannerHandler(0);

    function adjustIframeHeight($iframe) {
        try {
            // var newHeight = $($iframe[0].contentDocument.body).height();
            // newHeight = newHeight == 0 ? 365 : newHeight;
            var newHeight = 365;
            $iframe.css('--iframe-height', newHeight+'px');
            
        } catch (error) {
        }
    }

    if ($iframeMailing.length > 0) {
        $iframeMailing.on('load', function () {
            adjustIframeHeight($iframeMailing);
        });
    }

    var lastScrollTop = 0; 
    window.addEventListener("scroll", function(){
        var st = window.pageYOffset || document.documentElement.scrollTop; // Credits: "https://github.com/qeremy/so/blob/master/so.dom.js#L426"
        var count = 0;
        count = st / 10;
        var topLeft = 20;
        var topRight = 40;
        var topLeftPct = parseFloat(topLeft + count);
        var topRightPct = parseFloat(topRight + count);
        
        navHandler.$leftFloatingLogo.css({
            'left': parseFloat(0 - count)+'px',
            'top': Math.min(topLeftPct, 100)+'%'  
        });
        navHandler.$rightFloatingLogo.css({
            'right': parseFloat(0 - count)+'px',
            'top': Math.min(topRightPct, 100) +'%'
        });
        lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling

        navHandler.bannerHandler(st);
    }, false);

    $(document).on("click", "a", function(e) {
        var url = $(this).attr("href");
        if (typeof url !== 'undefined' && url[0] == '#') {
            e.preventDefault();
            url = url.substring(1);
            navHandler.activateItemIntoView(url);
        }
    });

    $(window).on("load", function() {
        var urlHash = window.location.hash;
        if (urlHash) {
            urlHash = urlHash.substring(1);
            navHandler.activateItemIntoView(urlHash);
        }
        // auto-open mailing list join
        var urlParams = new window.URLSearchParams(window.location.search);
        if (urlParams.get('signup-newsletter')) {
            $('#mailing-list-join-form').trigger('submit');
        }
    });

    $(window).on('resize', function() {
        navHandler.adjustMainMarginTop();
    }).trigger('resize');
    
    $('body').on('accessibility.optionchanged', function() {
        navHandler.bannerHandler();
        navHandler.adjustMainMarginTop();
        $('[data-masonry]').masonry( 'layout' );
        $('[data-sticky]').each(function() {
            Foundation.reInit($(this));
        });
    });

    $('.form-email').on('submit', function(e) {
        e.preventDefault();
        var $form = $(this);
        var $targetPanel = $('.reveal#'+$form.data('target-panel'));
        $targetPanel.find('.ginput_container_email input').val($form.find('input.input-email').val());
        $targetPanel.foundation('open');

        adjustIframeHeight($iframeMailing);
    });
    $('.mailing-list-reveal').on("open.zf.reveal", function() {
        $(this).find('input').eq(0).focus();
    });

});